/**
 * UNC Tar Heels shared constants.
 * Single source of truth for colors, risk mappings, and shared helpers.
 *
 * Official palette from Carolina Athletics Brand Identity Guidelines:
 *   Primary:   Carolina Blue #7BAFD4, White #FFFFFF
 *   Secondary: Navy Blue #13294B, Pitch Black #2C2A29, Silver #8D9092, Flat Grey #A2AAAD
 */

// ── Primary Palette ──────────────────────────────────────────────────────
export const CAROLINA_BLUE = '#7BAFD4';   // Pantone 542C — primary brand color
export const WHITE = '#FFFFFF';

// ── Secondary Palette ────────────────────────────────────────────────────
export const NAVY_BLUE = '#13294B';       // Pantone 2767C — dark contrast, headers on light bg
export const PITCH_BLACK = '#2C2A29';     // Pantone Process Black C — text on light bg
export const SILVER = '#8D9092';          // Pantone 877 C Metallic — secondary text
export const FLAT_GREY = '#A2AAAD';       // Pantone 429 C — muted text, borders

// ── Dark-Mode Adapted (SLAM dark theme-safe variants) ────────────────────
export const CAROLINA_BLUE_MUTED = '#5A8FB2';  // Dimmed for subtle accents on dark bg
export const CAROLINA_BLUE_DIM = '#1A3448';    // Very dark tint for dark-mode card fills
export const NAVY_LIGHT = '#1E3A5F';           // Lightened navy for dark-mode borders/cards

// ── Accent (Carolina Blue as primary) ────────────────────────────────────
export const ACCENT = CAROLINA_BLUE;

// ── Functional Colors ────────────────────────────────────────────────────
export const RISK_COLORS = {
  LOW: '#00CC66',
  MEDIUM: '#F59E0B',
  HIGH: '#FF4444',
};

export const RISK_ORDER = { HIGH: 0, MEDIUM: 1, LOW: 2 };

/**
 * Derive initials from a player name string.
 * "Vance Honeycutt" → "VH", "Honeycutt" → "H", "" → "?"
 */
export function getInitials(name) {
  const parts = (name || '').split(' ').filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[parts.length - 1][0]}`;
  return (parts[0] || '?')[0];
}
